import { render } from "./SearchTerm.vue?vue&type=template&id=3fe2c09a"
import script from "./SearchTerm.vue?vue&type=script&lang=js"
export * from "./SearchTerm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__